import {
  ActivatedRouteSnapshot,
  UrlTree,
  createUrlTreeFromSnapshot,
} from "@angular/router";
import { inject } from "@angular/core";
import { Observable, map } from "rxjs";
import { IsPlayerAlredySelected } from "@app/core/match/domain/is-player-already-selected.use-case";

export const playerAlreadySelectedGuard = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> => {
  // If the player is already select, it should redirect to the match detail.
  return inject(IsPlayerAlredySelected)
    .execute(route)
    .pipe(map((res) => res || createUrlTreeFromSnapshot(route, ["../"])));
};
